import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "flex flex-col mb-3" }
const _hoisted_2 = { class: "flex flex-col mb-3" }
const _hoisted_3 = { class: "flex flex-col mb-3" }
const _hoisted_4 = { class: "flex justify-center items-center gap-3" }
const _hoisted_5 = {
  key: 0,
  class: "grid grid-cols-1 gap-3"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex justify-end" }
const _hoisted_8 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_9 = { class: "max-w-screen-2xl m-auto pt-5" }
const _hoisted_10 = { class: "flex justify-between" }
const _hoisted_11 = { class: "rotate-x-180 overflow-x-scroll" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_ConfirmDelete = _resolveComponent("ConfirmDelete")!
  const _component_TabellaContextMenu = _resolveComponent("TabellaContextMenu")!
  const _component_NextTable = _resolveComponent("NextTable")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"]),
      _createVNode(_component_Modal, {
        visible: _ctx.modalVisible,
        "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.modalVisible) = $event))
      }, {
        main: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_Field, {
              field_name: "Tipo documento",
              errors: _ctx.errors?.tipo_documento_id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  options: _ctx.tipoDocumentoAutocomplete.options,
                  modelValue: _ctx.tipoDocumentoAutocomplete.selection,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tipoDocumentoAutocomplete.selection) = $event)),
                  loading: _ctx.tipoDocumentoAutocomplete.isLoading,
                  onSearchChange: _ctx.tipoDocumentoAutocomplete.search,
                  class: "next-vue-multiselect-single overflow-ellipsis mb-3",
                  "close-on-select": true,
                  "clear-on-select": false,
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  "track-by": "id",
                  label: "descrizione",
                  placeholder: "Tipo documento",
                  titolo: "Tipo documento"
                }, {
                  noResult: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  _: 1
                }, 8, ["options", "modelValue", "loading", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Field, {
              field_name: "Fornitore",
              errors: _ctx.errors?.fornitore_id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  options: _ctx.fornitoreAutocomplete.options,
                  modelValue: _ctx.fornitoreAutocomplete.selection,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fornitoreAutocomplete.selection) = $event)),
                  loading: _ctx.fornitoreAutocomplete.isLoading,
                  onSearchChange: _ctx.fornitoreAutocomplete.search,
                  class: "next-vue-multiselect-single overflow-ellipsis mb-3",
                  "close-on-select": true,
                  "clear-on-select": false,
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  "track-by": "id",
                  label: "denominazione",
                  placeholder: "Cerca fornitore",
                  titolo: "Fornitore"
                }, {
                  noResult: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createTextVNode("Nessun elemento trovato.")
                  ])),
                  singleLabel: _withCtx(({ option }) => [
                    _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                  ]),
                  option: _withCtx(({ option }) => [
                    _createTextVNode(_toDisplayString(`${option.denominazione} - ${option.ragione_sociale}`), 1)
                  ]),
                  _: 1
                }, 8, ["options", "modelValue", "loading", "onSearchChange"])
              ]),
              _: 1
            }, 8, ["errors"])
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Field, {
              field_name: "File",
              errors: _ctx.errors?.file_id
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FileUpload, {
                  uploaded_files: _ctx.uploaded,
                  "onUpdate:uploaded_files": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.uploaded) = $event)),
                  accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                }, {
                  default: _withCtx(({ props, methods }) => [
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_component_NextButton, {
                        variant: "outline-secondary",
                        onClick: methods.open,
                        class: "w-56 h-10 px-4 grow"
                      }, {
                        default: _withCtx(() => _cache[7] || (_cache[7] = [
                          _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                          _createTextVNode(" Allega ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    (_ctx.uploaded)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded, (f, idx) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "underline text-sm text-next-atp pt-3 cursor-pointer",
                              onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                              key: idx
                            }, [
                              _createElementVNode("span", null, _toDisplayString(f.name), 1)
                            ], 8, _hoisted_6))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["uploaded_files"])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_NextButton, {
              onClick: _ctx.close,
              variant: "outline-secondary",
              class: "w-44 py-1 px-2 mr-2"
            }, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("Chiudi ")
              ])),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_NextButton, {
              onClick: _ctx.saveFile,
              variant: "outline-primary",
              class: "w-44 py-1 px-2"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("Salva ")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "text-3xl font-bold mb-4" }, "Documenti Fornitori", -1)),
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _ctx.add,
            class: "ml-4 py-1 px-2"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode(" Aggiungi ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_NextTable, {
            class: "rotate-x-180 table-auto w-full border-separate border-spacing-3 py-4",
            cols: _ctx.cols,
            "onUpdate:cols": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.cols) = $event)),
            rows: _ctx.lista.rows,
            onOrderUpdate: _ctx.lista.updateCols
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_0`,
                fn: _withCtx((context) => [
                  _createVNode(_component_TabellaContextMenu, {
                    menuClass: "shadow absolute flex flex-col text-left whitespace-nowrap cursor-pointer p-3 bg-white",
                    buttonClass: "bg-next-gray-md-dark cursor-pointer block text-center absolute inset-0 flex items-center justify-center hover:bg-next-orange",
                    context: c,
                    id: j,
                    teleport_to: "#modal",
                    cmOpener: _ctx.cmOpener
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", {
                        onClick: ($event: any) => (_ctx.modificaRiga(c)),
                        class: "w-full hover:text-next-neu mb-2"
                      }, "Modifica", 8, _hoisted_12),
                      _createVNode(_component_ConfirmDelete, {
                        position: "right",
                        onCancella: ($event: any) => (_ctx.cancellaRiga(c.id))
                      }, {
                        default: _withCtx(() => _cache[12] || (_cache[12] = [
                          _createElementVNode("span", { class: "cursor-pointer hover:text-next-neu" }, "Elimina", -1)
                        ])),
                        _: 2
                      }, 1032, ["onCancella"])
                    ]),
                    _: 2
                  }, 1032, ["context", "id", "cmOpener"])
                ])
              }
            }),
            _renderList(_ctx.lista.rows, (c, j) => {
              return {
                name: `td_${j}_3`,
                fn: _withCtx(({ context }) => [
                  _createElementVNode("a", {
                    class: "underline text-sm text-next-atp break-words cursor-pointer",
                    onClick: ($event: any) => (_ctx.downloadFile(c.file_id))
                  }, _toDisplayString(c.file.name), 9, _hoisted_13)
                ])
              }
            })
          ]), 1032, ["cols", "rows", "onOrderUpdate"])
        ]),
        _createVNode(_component_InfiniteLoading, {
          onInfinite: _ctx.lista.fetchNextPage,
          identifier: _ctx.lista.infiniteIdentifier,
          style: {"min-height":"1px"}
        }, {
          complete: _withCtx(() => _cache[13] || (_cache[13] = [
            _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre righe.", -1)
          ])),
          _: 1
        }, 8, ["onInfinite", "identifier"])
      ])
    ])
  ], 64))
}